// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"9c632304","474":"11e3523a"}[chunkId] + ".chunk.js";
};